<template>
    <div class="container py-4">
        <h2 class="mb-4 text-center">Área de pruebas (Sandbox)</h2>

        <div class="alert alert-warning mt-3">
            Estás en el <strong>entorno de pruebas (Sandbox)</strong>. Los datos no serán almacenados permanentemente.
        </div>

        <!-- Nav tabs -->
        <ul class="nav nav-tabs mb-3" id="sandboxTabs" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link active" id="solo-datos-tab" data-bs-toggle="tab" data-bs-target="#solo-datos" type="button" role="tab">
                    Enviar solo archivo de datos
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="con-respaldo-tab" data-bs-toggle="tab" data-bs-target="#con-respaldo" type="button" role="tab">
                    Enviar archivo de datos + respaldos
                </button>
            </li>
        </ul>

        <!-- Tab panes -->
        <div class="tab-content">
            <!-- Tab 1 -->
            <div class="tab-pane fade show active" id="solo-datos" role="tabpanel">
                <form @submit.prevent="enviarSoloDatos" class="border p-4 rounded bg-light shadow-sm">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h5 class="mb-0">Formulario: Solo datos</h5>
                        <a href="/docs/Estructura del archivo para la carga de datos de atenciones médicas.pdf"
                           target="_blank" class="text-decoration-none" title="Ver ayuda en PDF">
                            Estructura del archivo para la carga de datos de atenciones médicas
                        </a>
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Fecha Desde</label>
                        <input v-model="form.fechaDesde" type="date" class="form-control" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Fecha Hasta</label>
                        <input v-model="form.fechaHasta" type="date" class="form-control" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label">ID Usuario</label>
                        <input v-model.number="form.idUsuario" type="number" class="form-control" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label">ID Autorización (opcional)</label>
                        <input v-model.number="form.idAutorizacion" type="number" class="form-control" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Fecha Modificación</label>
                        <input v-model="form.fechaModificacion" type="date" class="form-control" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Archivo JSON de Datos</label>
                        <input type="file" accept=".json" @change="handleArchivoDatos" class="form-control" />
                    </div>

                    <button type="submit" class="btn btn-primary">Enviar solo archivo de datos</button>
                </form>
            </div>

            <!-- Tab 2 -->
            <div class="tab-pane fade" id="con-respaldo" role="tabpanel">
                <form @submit.prevent="enviarDatosYRespaldo" class="border p-4 rounded bg-light shadow-sm">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h5 class="mb-0">Formulario: Datos + respaldos</h5>
                        <a href="/docs/Cómo organizar la carpeta contenedora de los archivos de respaldo.pdf"
                           target="_blank" class="text-decoration-none" title="Ver ayuda en PDF">
                            ¿Cómo organizar la carpeta contenedora de los archivos de respaldo?
                        </a>
                    </div>
                    <!-- resto del formulario -->


                    <div class="mb-3">
                        <label class="form-label">Fecha Desde</label>
                        <input v-model="form.fechaDesde" type="date" class="form-control" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Fecha Hasta</label>
                        <input v-model="form.fechaHasta" type="date" class="form-control" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Servicio</label>
                        <select v-model="form.idServicio" class="form-select">
                            <option :value="1">Ambulatorio</option>
                            <option :value="2">Hospitalario</option>
                        </select>
                    </div>

                    <div class="mb-3">
                        <label class="form-label">ID Usuario</label>
                        <input v-model.number="form.idUsuario" type="number" class="form-control" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label">ID Autorización (opcional)</label>
                        <input v-model.number="form.idAutorizacion" type="number" class="form-control" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Fecha Modificación</label>
                        <input v-model="form.fechaModificacion" type="date" class="form-control" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Archivo JSON de Datos</label>
                        <input type="file" accept=".json" @change="handleArchivoDatos" class="form-control" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Carpeta de respaldos (archivos múltiples)</label>
                        <input type="file" @change="handleRespaldoFiles" webkitdirectory directory multiple class="form-control" />
                    </div>

                    <button type="submit" class="btn btn-success">Enviar datos y respaldos</button>
                </form>
            </div>
        </div>
    </div>
    <router-link to="/" class="btn btn-outline-primary mb-3">
        ← Volver al inicio
    </router-link>
</template>

<script setup>
    import { ref } from 'vue'
    import axios from 'axios'

    // Modelo del formulario
    const form = ref({
      fechaDesde: '',
      fechaHasta: '',
      idUsuario: '',
      idAutorizacion: '',
      fechaModificacion: ''
    })

    const archivoDatos = ref(null)
    const archivosRespaldo = ref([])

    const handleArchivoDatos = (e) => {
      archivoDatos.value = e.target.files[0]
    }

    const handleRespaldoFiles = (e) => {
      archivosRespaldo.value = Array.from(e.target.files)
    }

    const enviarSoloDatos = async () => {
      try {
        const formData = new FormData()
        formData.append('fechaDesde', form.value.fechaDesde)
        formData.append('fechaHasta', form.value.fechaHasta)
        formData.append('idUsuario', form.value.idUsuario)
        formData.append('idServicio', form.value.idServicio)
        if (form.value.idAutorizacion) {
          formData.append('idAutorizacion', form.value.idAutorizacion)
        }
        formData.append('fechaModificacion', form.value.fechaModificacion)
        formData.append('archivoDatos', archivoDatos.value)

        const response = await axios.post('http://localhost:8080/api/v1/sandbox/cargatramites/registro-datos', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        alert('Carga exitosa: ' + JSON.stringify(response.data))
      } catch (error) {
        if (error.response && error.response.status === 400) {
          const message = error.response.data?.message || '';
          if (message.includes('archivoDatos') || message.includes('Required request part')) {
            alert('Debe adjuntar un archivo de datos para continuar.');
          } else {
            alert('Solicitud incorrecta: Verifique los datos enviados.');
          }
        } else {
          alert('Error de comunicación con el servidor. Intente más tarde.');
        }
        console.error('Error en carga de solo datos:', error)
      }
    }

    const enviarDatosYRespaldo = async () => {
      try {
        const formData = new FormData()
        formData.append('fechaDesde', form.value.fechaDesde)
        formData.append('fechaHasta', form.value.fechaHasta)
        formData.append('idUsuario', form.value.idUsuario)
        formData.append('idServicio', form.value.idServicio)
        if (form.value.idAutorizacion) {
          formData.append('idAutorizacion', form.value.idAutorizacion)
        }
        formData.append('fechaModificacion', form.value.fechaModificacion)
        formData.append('archivoDatos', archivoDatos.value)

        archivosRespaldo.value.forEach((file) => {
          formData.append('archivosRespaldo', file)
        })

        const response = await axios.post('http://localhost:8080/api/v1/sandbox/cargatramites/registro-completo', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        alert('Carga completa exitosa: ' + JSON.stringify(response.data))
      } catch (error) {
        if (error.response && error.response.status === 400) {
          const message = error.response.data?.message || '';
          if (message.includes('archivoDatos') || message.includes('Required request part')) {
            alert('Debe adjuntar un archivo de datos para continuar.');
          } else {
            alert('Solicitud incorrecta: Verifique los datos enviados.');
          }
        } else {
          alert('Error de comunicación con el servidor. Intente más tarde.');
        }
        console.error('Error en carga completa:', error)
      }
    }
</script>
